import React, {
    useState
} from "react";


import EconomicsEngine from "../engine/EconomicsEngine";
import EquipmentEngine from "../engine/EquipmentEngine";

import "./EconomicsDashboard.css";



function EconomicsDashboard() {


    const [activeModule, setActiveModule] = useState("Production");

    const [refreshProduction, setRefreshProduction] = useState(0);
    const [selectedCurrency, setSelectedCurrency] = useState("USD");


    const currencies = [
        { code: "USD", symbol: "{economics.currencySymbol}", name: "US Dollar" },
        { code: "NGN", symbol: "₦", name: "Naira" },
        { code: "GBP", symbol: "£", name: "Pounds" },
        { code: "EUR", symbol: "€", name: "Euro" },
        { code: "CNY", symbol: "¥", name: "Chinese Yuan" },
        { code: "INR", symbol: "₹", name: "Indian Rupee" },
        { code: "GHS", symbol: "GH₵", name: "Ghana Cedis" }
    ];



    const economics =
        EconomicsEngine();

        const {
    currency,
    setCurrency,
    currencySymbol,
    convertCurrency
} = economics;



    const equipment =
        EquipmentEngine();

    const products = [

        "Crude",
        "LPG",
        "Naphtha",
        "Kerosene",
        "Diesel",
        "Residue"

    ];

    const resetToday = () => {

        if (!window.confirm("Reset Today's Production?")) return;

        products.forEach(product => {

            localStorage.removeItem(`ECON_{economics.currencySymbol}{product}_TODAY`);

        });

        setRefreshProduction(prev => prev + 1);

    };

    const resetMonth = () => {

        if (!window.confirm("Reset Monthly Production?")) return;

        products.forEach(product => {

            localStorage.removeItem(`ECON_{economics.currencySymbol}{product}_MONTH`);

        });

        setRefreshProduction(prev => prev + 1);

    };

    const resetYear = () => {

        if (!window.confirm("Reset Yearly Production?")) return;

        products.forEach(product => {

            localStorage.removeItem(`ECON_{economics.currencySymbol}{product}_YEAR`);

        });

        setRefreshProduction(prev => prev + 1);

    };

    const resetAll = () => {

        if (!window.confirm("Reset ALL Production Records?")) return;

        products.forEach(product => {

            localStorage.removeItem(`ECON_{economics.currencySymbol}{product}_TODAY`);
            localStorage.removeItem(`ECON_{economics.currencySymbol}{product}_MONTH`);
            localStorage.removeItem(`ECON_{economics.currencySymbol}{product}_YEAR`);

        });

        setRefreshProduction(prev => prev + 1);

    };


    const navigation = [

        {
            name: "Production",
            icon: "📦"
        },

        {
            name: "Revenue",
            icon: "💰"
        },

        {
            name: "Utilities",
            icon: "⚡"
        },

        {
            name: "Equipment",
            icon: "🏭"
        },

        {
            name: "Losses",
            icon: "📉"
        },

        {
            name: "Forecast",
            icon: "📈"
        },

        {
            name: "Econometrics",
            icon: "🧠"
        }

    ];





    const renderModule = () => {

        switch (activeModule) {


            case "Production":

                return (

                    <>

                        <div className="production-header">

                            <div className="section-title-header">

                                <span>

                                    Production Performance Dashboard

                                </span>

                            </div>

                            <div className="reset-menu">

                                <button className="reset-main">

                                    RESET

                                </button>

                                <div className="reset-dropdown">

                                    <div onClick={resetToday}>🔄 Reset Today</div>

                                    <div onClick={resetMonth}>📅 Reset Month</div>

                                    <div onClick={resetYear}>📆 Reset Year</div>

                                    <div onClick={resetAll}>🗑 Reset All</div>

                                </div>

                            </div>

                        </div>



                        {/* =====================================
                LIVE SUMMARY CARDS
            ===================================== */}

                        <div className="production-summary-grid">

                            <div className="summary-box">

                                <h4>Crude Feed</h4>

                                <span>

                                    {economics.convertCurrency(economics.production.Crude.cumulativeDaily).toFixed(1)}

                                </span>

                                <small>

                                    bbl Today

                                </small>

                            </div>

                            <div className="summary-box">

                                <h4>LPG</h4>

                                <span>

                                    {economics.convertCurrency(economics.production.LPG.cumulativeDaily).toFixed(1)}

                                </span>

                                <small>

                                    bbl Today

                                </small>

                            </div>

                            <div className="summary-box">

                                <h4>Naphtha</h4>

                                <span>

                                    {economics.convertCurrency(economics.production.Naphtha.cumulativeDaily).toFixed(1)}

                                </span>

                                <small>

                                    bbl Today

                                </small>

                            </div>

                            <div className="summary-box">

                                <h4>Kerosene</h4>

                                <span>

                                    {economics.convertCurrency(economics.production.Kerosene.cumulativeDaily).toFixed(1)}

                                </span>

                                <small>

                                    bbl Today

                                </small>

                            </div>

                            <div className="summary-box">

                                <h4>Diesel</h4>

                                <span>

                                    {economics.convertCurrency(economics.production.Diesel.cumulativeDaily).toFixed(1)}

                                </span>

                                <small>

                                    bbl Today

                                </small>

                            </div>

                            <div className="summary-box">

                                <h4>Residue</h4>

                                <span>

                                    {economics.convertCurrency(economics.production.Residue.cumulativeDaily).toFixed(1)}

                                </span>

                                <small>

                                    bbl Today

                                </small>

                            </div>

                        </div>



                        {/* =====================================
                PRODUCTION TABLE
            ===================================== */}

                        <div className="production-table">

                            <table>

                                <thead>

                                    <tr>

                                        <th>Product</th>

                                        <th>Live Flow</th>

                                        <th>Current Rate</th>

                                        <th>Produced Today</th>

                                        <th>Produced This Month</th>

                                        <th>Produced This Year</th>

                                        <th>Status</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    {

                                        Object.entries(economics.production).map(

                                            ([name, data]) => (

                                                <tr key={name}>

                                                    <td>

                                                        {name}

                                                    </td>

                                                    <td>

                                                        {data.flow.toFixed(2)}

                                                        {" "}

                                                        bpm

                                                    </td>

                                                    <td>

                                                        {data.daily.toFixed(1)}

                                                        {" "}

                                                        BPD

                                                    </td>

                                                    <td>

                                                        {data.cumulativeDaily.toFixed(1)}

                                                        {" "}

                                                        bbl

                                                    </td>

                                                    <td>

                                                        {data.cumulativeMonthly.toFixed(1)}

                                                        {" "}

                                                        bbl

                                                    </td>

                                                    <td>

                                                        {data.cumulativeYearly.toFixed(1)}

                                                        {" "}

                                                        bbl

                                                    </td>

                                                    <td>

                                                        {

                                                            data.flow > 0

                                                                ?

                                                                <span className="status-running">

                                                                    ● Producing

                                                                </span>

                                                                :

                                                                <span className="status-paused">

                                                                    ● Idle

                                                                </span>

                                                        }

                                                    </td>

                                                </tr>

                                            )

                                        )

                                    }

                                </tbody>

                            </table>

                        </div>

                    </>

                );



            case "Revenue":

                return (

                    <>

                        <div className="section-title-header">

                            <span>

                                Revenue Performance Dashboard

                            </span>

                        </div>


                        {/*==============================
                SUMMARY
            ==============================*/}

                        <div className="production-summary-grid">

                            <div className="summary-box">

                                <h4>Daily Revenue</h4>

                                <span>

                                    {economics.currencySymbol}

                                    {economics.convertCurrency(economics.revenue.Total.daily).toFixed(0)}

                                </span>

                            </div>

                            <div className="summary-box">

                                <h4>Monthly Revenue</h4>

                                <span>

                                    {economics.currencySymbol}

                                    {economics.convertCurrency(economics.revenue.Total.monthly).toFixed(0)}

                                </span>

                            </div>

                            <div className="summary-box">

                                <h4>Yearly Revenue</h4>

                                <span>

                                    {economics.currencySymbol}

                                    {economics.convertCurrency(economics.revenue.Total.yearly).toFixed(0)}

                                </span>

                            </div>

                            <div className="summary-box">

                                <h4>Gross Margin</h4>

                                <span>

                                    {economics.currencySymbol}

                                    {economics.convertCurrency(economics.econometrics.grossRefiningMargin).toFixed(0)}

                                </span>

                            </div>

                            <div className="summary-box">

                                <h4>Operating Margin</h4>

                                <span>

                                    {economics.convertCurrency(economics.profitability.operatingMargin).toFixed(2)}%

                                </span>

                            </div>

                            <div className="summary-box">

                                <h4>Net Profit</h4>

                                <span>

                                    {economics.currencySymbol}

                                    {economics.convertCurrency(economics.profitability.dailyProfit).toFixed(0)}

                                </span>

                            </div>

                        </div>


                        {/*==============================
                TABLE
            ==============================*/}

                        {/* =======================================
        PRODUCT REVENUE BREAKDOWN
======================================= */}

                        <div className="revenue-table">

                            <table>

                                <thead>

                                    <tr>

                                        <th>Product</th>

                                        <th>Flow</th>

                                        <th>Price</th>

                                        <th>Daily Revenue</th>

                                        <th>Monthly Revenue</th>

                                        <th>Yearly Revenue</th>

                                        <th>% Contribution</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    {

                                        ["LPG", "Naphtha", "Kerosene", "Diesel", "Residue"]

                                            .map(product => {

                                                const item = economics.revenue[product];

                                                const prod = economics.production[product];

                                                const contribution =

                                                    economics.revenue.Total.daily > 0

                                                        ?

                                                        (

                                                            item.daily /

                                                            economics.revenue.Total.daily

                                                        ) * 100

                                                        :

                                                        0;

                                                return (

                                                    <tr key={product}>

                                                        <td>

                                                            {product}

                                                        </td>

                                                        <td>

                                                            {prod.flow.toFixed(2)} bpm

                                                        </td>

                                                        <td>

                                                            {economics.currencySymbol}

                                                            {item.price.toFixed(2)}

                                                            /bbl

                                                        </td>

                                                        <td>

                                                            {economics.currencySymbol}

                                                            {item.daily.toLocaleString()}

                                                        </td>

                                                        <td>

                                                            {economics.currencySymbol}

                                                            {item.monthly.toLocaleString()}

                                                        </td>

                                                        <td>

                                                            {economics.currencySymbol}

                                                            {item.yearly.toLocaleString()}

                                                        </td>

                                                        <td>

                                                            {contribution.toFixed(1)}%

                                                        </td>

                                                    </tr>

                                                );

                                            })

                                    }

                                </tbody>

                            </table>

                        </div>

                        {/* =======================================
        PRODUCT CONTRIBUTION
======================================= */}

                        <div className="revenue-bars">

                            {

                                ["LPG", "Naphtha", "Kerosene", "Diesel", "Residue"]

                                    .map(product => {

                                        const contribution =

                                            economics.revenue.Total.daily > 0

                                                ?

                                                (

                                                    economics.revenue[product].daily /

                                                    economics.revenue.Total.daily

                                                ) * 100

                                                :

                                                0;

                                        return (

                                            <div
                                                className="revenue-bar-row"
                                                key={product}
                                            >

                                                <div className="bar-name">

                                                    {product}

                                                </div>

                                                <div className="bar-track">

                                                    <div

                                                        className="bar-fill"

                                                        style={{

                                                            width: `{economics.currencySymbol}{contribution}%`

                                                        }}

                                                    />

                                                </div>

                                                <div className="bar-value">

                                                    {contribution.toFixed(1)}%

                                                </div>

                                            </div>

                                        );

                                    })

                            }

                        </div>

                        {/*==================================
    EXECUTIVE REVENUE SUMMARY
==================================*/}

                        <div className="revenue-summary-grid">

                            <div className="revenue-card">

                                <h4>💰 Daily Revenue</h4>

                                <span>

                                    {economics.currencySymbol}

                                    {economics.convertCurrency(economics.revenue.Total.daily).toLocaleString(undefined, {
                                        maximumFractionDigits: 0
                                    })}

                                </span>

                                <small>Total Product Sales Today</small>

                            </div>

                            <div className="revenue-card">

                                <h4>📅 Monthly Revenue</h4>

                                <span>

                                    {economics.currencySymbol}

                                    {economics.convertCurrency(economics.revenue.Total.monthly).toLocaleString(undefined, {
                                        maximumFractionDigits: 0
                                    })}

                                </span>

                                <small>Total Product Sales This Month</small>

                            </div>

                            <div className="revenue-card">

                                <h4>📆 Yearly Revenue</h4>

                                <span>

                                    {economics.currencySymbol}

                                    {economics.convertCurrency(economics.revenue.Total.yearly).toLocaleString(undefined, {
                                        maximumFractionDigits: 0
                                    })}

                                </span>

                                <small>Total Product Sales This Year</small>

                            </div>

                            <div className="revenue-card">

                                <h4>🏆 Gross Margin</h4>

                                <span>

                                    {economics.currencySymbol}

                                    {economics.convertCurrency(economics.econometrics.grossRefiningMargin).toLocaleString(undefined, {
                                        maximumFractionDigits: 0
                                    })}

                                </span>

                                <small>Revenue − Crude Cost</small>

                            </div>

                            <div className="revenue-card">

                                <h4>📈 Operating Margin</h4>

                                <span>

                                    {economics.convertCurrency(economics.profitability.operatingMargin).toFixed(2)}%

                                </span>

                                <small>Plant Profitability</small>

                            </div>

                            <div className="revenue-card">

                                <h4>💵 Net Profit</h4>

                                <span>

                                    {economics.currencySymbol}

                                    {economics.convertCurrency(economics.profitability.dailyProfit).toLocaleString(undefined, {
                                        maximumFractionDigits: 0
                                    })}

                                </span>

                                <small>Today's Estimated Profit</small>

                            </div>

                            <div className="revenue-card">

                                <h4>🛢 Revenue / Barrel</h4>

                                <span>

                                    {economics.currencySymbol}

                                    {economics.convertCurrency(economics.econometrics.revenuePerBarrel).toFixed(2)}

                                </span>

                                <small>Average Sales Value</small>

                            </div>

                            <div className="revenue-card">

                                <h4>💲 Profit / Barrel</h4>

                                <span>

                                    {economics.currencySymbol}

                                    {economics.convertCurrency(economics.econometrics.profitPerBarrel).toFixed(2)}

                                </span>

                                <small>Average Profit Generated</small>

                            </div>

                        </div>

                        {/* ======================================
        PROFIT WATERFALL
====================================== */}

                        <div className="waterfall-container">

                            <h3>Profit Waterfall Analysis</h3>

                            <div className="waterfall">

                                <div className="waterfall-item positive">

                                    <span>Gross Revenue</span>

                                    <strong>
                                        {economics.currencySymbol}
                                        {economics.convertCurrency(economics.revenue.Total.daily).toLocaleString()}
                                    </strong>

                                </div>

                                <div className="waterfall-arrow">
                                    ▼
                                </div>

                                <div className="waterfall-item negative">

                                    <span>Crude Feed Cost</span>

                                    <strong>
                                        -{economics.currencySymbol}
                                        {economics.convertCurrency(economics.crudeCost.daily).toLocaleString()}
                                    </strong>

                                </div>

                                <div className="waterfall-arrow">
                                    ▼
                                </div>

                                <div className="waterfall-item negative">

                                    <span>Utility Cost</span>

                                    <strong>
                                        -{economics.currencySymbol}
                                        {economics.convertCurrency(economics.utilities.totalDaily).toLocaleString()}
                                    </strong>

                                </div>

                                <div className="waterfall-arrow">
                                    ▼
                                </div>

                                <div className="waterfall-item negative">

                                    <span>Equipment Cost</span>

                                    <strong>
                                        -{economics.currencySymbol}
                                        {economics.convertCurrency(economics.equipment.totalDaily).toLocaleString()}
                                    </strong>

                                </div>

                                <div className="waterfall-arrow">
                                    ▼
                                </div>

                                <div className="waterfall-item negative">

                                    <span>Losses</span>

                                    <strong>
                                        -{economics.currencySymbol}
                                        {economics.convertCurrency(economics.losses.lossValue.daily).toLocaleString()}
                                    </strong>

                                </div>

                                <div className="waterfall-arrow">
                                    ▼
                                </div>

                                <div className="waterfall-item profit">

                                    <span>Net Profit</span>

                                    <strong>
                                        {economics.currencySymbol}
                                        {economics.convertCurrency(economics.profitability.netProfit).toLocaleString()}
                                    </strong>

                                </div>

                            </div>

                        </div>


                        {/* ======================================
        REVENUE TREND
====================================== */}

                        <div className="revenue-trend-container">

                            <h3>

                                Revenue Trend

                            </h3>

                            <div className="revenue-trend-grid">

                                {

                                    economics.revenueTrend.map(item => (

                                        <div

                                            key={item.period}

                                            className="trend-card"

                                        >

                                            <span>

                                                {item.period}

                                            </span>

                                            <strong>

                                                {economics.currencySymbol}

                                                {item.revenue.toLocaleString()}

                                            </strong>

                                        </div>

                                    ))

                                }

                            </div>

                        </div>

                    </>

                );


            case "Utilities":

                return (

                    <>

                        <div className="section-title-header">

                            <span>

                                Utility Cost Analysis

                            </span>

                        </div>


                        <p>

                            Steam,
                            Fuel Gas,
                            Electricity and Utility Consumption.

                        </p>

                    </>

                );



            case "Equipment":

                return (

                    <>

                        <div className="section-title-header">

                            <span>

                                Equipment Economics

                            </span>

                        </div>


                        <p>

                            Equipment Availability,
                            Energy Consumption,
                            Maintenance Cost and Health Index.

                        </p>

                    </>

                );



            case "Losses":

                return (

                    <>

                        <div className="section-title-header">

                            <span>

                                Loss Analysis

                            </span>

                        </div>


                        <p>

                            Production Losses,
                            Flare Losses,
                            Tank Losses and Off-Spec Product.

                        </p>

                    </>

                );



            case "Forecast":

                return (

                    <>

                        <div className="section-title-header">

                            <span>

                                Economic Forecast

                            </span>

                        </div>


                        <p>

                            Future Production,
                            Revenue Forecast and Scenario Prediction.

                        </p>

                    </>

                );



            case "Econometrics":

                return (

                    <>

                        <div className="section-title-header">

                            <span>

                                Econometrics Analysis

                            </span>

                        </div>


                        <p>

                            Regression Models,
                            Sensitivity Analysis,
                            Optimization and Predictive Models.

                        </p>

                    </>

                );



            default:

                return null;


        }

    };





    return (

        <div className="economics-dashboard">



            {/* ==================================
                HEADER
            ================================== */}


            <div className="economic-header">

                <div className="currency-menu">

                    <button className="currency-main">

                        {selectedCurrency}

                    </button>

                    <div className="currency-dropdown">

                        {

                            currencies.map(currency => (

                                <div
                                    key={currency.code}
                                    onClick={() => setSelectedCurrency(currency.code)}
                                >

                                    {currency.symbol}

                                    {" "}

                                    {currency.name}

                                </div>

                            ))

                        }

                    </div>

                </div>


                <h1>

                    NK REFINERY

                    <br />

                    ECONOMIC PERFORMANCE DASHBOARD

                </h1>



                <p>

                    Integrated Refinery Economic
                    Monitoring & Optimization Center

                </p>


            </div>






            {/* ==================================
                KPI SUMMARY CARDS
            ================================== */}



            <div className="dashboard-grid">



                <div className="card">


                    <h3>
                        📦 Production
                    </h3>


                    <p>

                        Crude:

                        <br />

                        {
                            economics
                                ?.production
                                ?.Crude
                                ?.daily
                                ?.toFixed(0)
                            ||
                            0
                        }

                        BPD

                    </p>


                </div>






                <div className="card">


                    <h3>
                        💰 Revenue
                    </h3>


                    <p>

                        Daily Revenue:

                        <br />

                        {economics.currencySymbol}

                        {
                            economics
                                ?.revenue
                                ?.Total
                                ?.daily
                                ?.toFixed(0)
                            ||
                            0
                        }


                    </p>


                </div>






                <div className="card">


                    <h3>
                        🏭 Equipment
                    </h3>



                    <p>

                        Running Pumps:

                        {" "}

                        {
                            equipment
                                ?.pumps
                                ?.running
                            ||
                            0
                        }


                    </p>



                    <p>

                        Running Air Coolers:

                        {" "}

                        {
                            equipment
                                ?.airCoolers
                                ?.running
                            ||
                            0
                        }


                    </p>


                </div>



            </div>








            {/* ==================================
                MAIN ECONOMIC AREA
            ================================== */}



            <div className="economic-layout">






                {/* LEFT MENU */}


                <div className="economic-navigation">


                    {

                        navigation.map(item => (


                            <div

                                key={item.name}


                                className={

                                    activeModule === item.name

                                        ?

                                        "economic-navigation-item active"

                                        :

                                        "economic-navigation-item"

                                }


                                onClick={() =>
                                    setActiveModule(item.name)
                                }


                            >


                                <span>

                                    {item.icon}

                                </span>


                                {item.name}


                            </div>


                        ))

                    }


                </div>







                {/* CONTENT AREA */}



                <div className="economic-content">


                    {renderModule()}


                </div>




            </div>






        </div>


    );


}



export default EconomicsDashboard;